import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { AdicionarContaForm } from "../typings";

interface UseAdicionarContaRateioProps {
  id: string;
  year: string;
  month: string;
  onSuccess: (data: any) => void;
}
function useAdicionarContaRateio({
  id,
  year,
  month,
  onSuccess,
}: UseAdicionarContaRateioProps) {
  const queryClient = useQueryClient();

  return useMutation(
    "contas/v1/rateio",
    ({ contas }: AdicionarContaForm) =>
      http.post(`/v1/rateio/${id}/${year}/${month}/contas`, {
        contas,
      }),
    {
      retry: false,
      onSuccess: (data) => {
        queryClient.invalidateQueries(
          `/v1/rateio/${id}/${year}/${month}/contas`
        );

        onSuccess?.(data);
      },
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useAdicionarContaRateio;
